const prod = require("./config.prod");
const staging = require("./config.staging");
const dev = require("./config.dev");
const mojProd = require("./config-moj-prod");
const mojStage = require("./config-moj-stag");

let config = staging;

let isMojProd = process.env.ACTIVE_ENV === 'PRODUCTION' && process.env.PROJECT_NAME === 'MOJ'

let isMojStaging = process.env.ACTIVE_ENV === 'STAGING' && process.env.PROJECT_NAME === 'MOJ'

if (isMojProd) {
	config = mojProd
}
else if (isMojStaging) {
	config = mojStage
}
else if (process.env.ACTIVE_ENV === "PRODUCTION") {
	config = prod;
} else if (process.env.ACTIVE_ENV === "STAGING") {
	config = staging;
} else {
	config = dev;
}

module.exports = config;
